import { billingCycles } from '@/core/ryanada'
import { HostingModel, ServerModel } from '@/models'
import { ProductViewModel } from '@/view-models'

export class ChangePriceView {
  constructor(
    widget: HTMLElement,
    model: HostingModel | ServerModel,
    productViewModel: ProductViewModel
  ) {
    const priceWidgets = widget.querySelectorAll<HTMLElement>(
      '.mini-pricing-table > .price'
    )

    priceWidgets.forEach((priceWidget) => {
      const billingCycleInput = priceWidget.querySelector<HTMLInputElement>(
        'input[name=billingcycle]'
      )

      const billingCycle = billingCycleInput?.value as billingCycles | undefined

      if (!billingCycle) {
        throw new Error('ChangePriceView: billingCycle null')
      }

      priceWidget.addEventListener('click', async (event) => {
        event.preventDefault()
        model.setBillingCycle(billingCycle)
        priceWidget.classList.add('price--is-loading')
        void (await productViewModel.addToCart(model))
        priceWidget.classList.remove('price--is-loading')
      })
    })
  }
}
